<template>
  <kst-page-print-list pageFooter
    v-slot="{ title }"
    :catalog="WhsSearchCatalog"
    :params="Model.Search.ListParams"
    :search="searchData"
    @init="handleInit"
  >
    <div class="columns is-mobile">
      <div class="column is-half">
        <Company :data="companyData"/>
      </div>
      <div class="column is-half">
        <div class="is-size-3">{{ title }}</div>
      </div>
    </div>

    <List class="mt-4" :dataList="dataList"/>
  </kst-page-print-list>
</template>

<script>
import Model from "../WhsModel.js";
import WhsSearchCatalog from "../WhsSearchCatalog.js";
import Services from "../../../services/Api/WarehouseService.js";

import List from "./WhsPL_List.vue";
import Company from "../../Company/RelatedPrintDetails/CpRPD.vue";

export default {
  components: {
    List,
    Company
  },
  data: () => ({
    Model: Model,
    WhsSearchCatalog: WhsSearchCatalog,
    companyData: {},
    dataList: [],
    searchData: {
      Search: "",
      IsActive: null
    }
  }),
  created() {
    this.resetSearch();
  },
  methods: {
    /*** by page ***/

    handleInit(loadPrint) {
      this.resetData();

      const options = this.getListOptions();
      const config = Services.getPrintListData(options);
      loadPrint(config, this.handleInit_success);
    },
    handleInit_success(data) {
      this.companyData = data.CompanyDetails;
      this.dataList = data.List;
    },

    /*** custom ***/

    resetData() {
      this.companyData = {};
      this.dataList = [];
    },
    
    resetSearch() {
      this.searchData.Search = "";
      this.searchData.IsActive = this.$kst.Search.OptionAll;
    },

    getListOptions() {
      return {
        active: this.$kst.Search.getValue(this.searchData.IsActive),
        search: this.$kst.Out.getString(this.searchData.Search),
        field: Model.Search.ListFields
      };
    }
  }
}
</script>